module.exports = __webpack_public_path__ + "img/productivity-module.f4bfcaa8.png";